import React from 'react';
import { View, TouchableOpacity, StyleSheet, Dimensions, SafeAreaView, ActivityIndicator, Animated, StatusBar, PanResponder } from 'react-native';
// import Video from 'react-native-video';
// import BackHandler from './../AndroidBackHandler';
import { withRouter } from 'react-router-dom';
// import Pdf from 'react-native-pdf';
// import { WebView } from 'react-native-webview';
import { Text, Styles } from "./../../components/UI-Components" 
// import OfflineHandler from './../OfflineHandler';
import JwPlayer from './jwPlayer';
import TextField from '@material-ui/core/TextField';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import ZoomIn from '@material-ui/icons/ZoomIn';
import MenuItem from '@material-ui/core/MenuItem';
// import {addNotes, clearAddNotesData} from './../../store/actions';
import Snackbar from '@material-ui/core/Snackbar';
import ReactDOM from 'react-dom';
import  PDFViewer from 'mgr-pdf-viewer-react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
// import ReactPlayer from 'react-player';
import { getGetHtmlContent, dispatchClearGetHtmlContent,getGetJwPlayerSourceFiles, clearGetJwPlayerSourceFiles } from "./../../store/actions";
import { Surface } from 'react-native-paper';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
// import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Viewer from '@phuocng/react-pdf-viewer';
import Fade from '@material-ui/core/Fade';


const _width = window.innerWidth;

 
function Transition(props) {
    const  Anime = _width <= 479 ? <Fade in={true} {...props} />  : <Slide direction="up" {...props} /> 
    return Anime;
  }
// const videoHeight = deviceWidth * 0.56;
const CustomPrevButton = (props) => {
    const {
      page,
      pages,
      handlePrevClick
    } = props;
    if (page === 1) return <div></div>;
  
    return <h3 style={{cursor: 'pointer', display: 'inline-block', marginRight: 24, marginTop: 0, color:'#000'}} onClick={handlePrevClick}>Previous page</h3>;
  };
  
  
  const CustomNextButton = (props) => {
    const {
      page,
      pages,
      handleNextClick
    } = props;
    if (page === pages) return <div></div>;
  
    return <h3 style={{cursor: 'pointer', display: 'inline-block', marginLeft: 24, marginTop: 0, color:'#000'}} onClick={handleNextClick}>Next page</h3>;
  };
  
  
   const CustomPages = (props) => {
    const {
      page,
      pages
    } = props;
    return <h3 style={{display: 'inline-block', marginTop: 0, color:'#000'}}>Page {page} from {pages}</h3>;
  };
// const LoadingComponent = ({value}) => (
//     <View>
//         <ActivityIndicator />
//         {/* <Animated.View  
//                 style={[  
//                     styles.inner,{width: value},  
//                 ]}  
//             />   */}
//             {/* <View
//              style={styles.percentageLoader}
//             >
//             <Animated.Text style={styles.label}>  
//                     {value} <Text style={{fontSize: 10}}>%</Text>
//             </Animated.Text>  
//             </View> */}
//     </View>
// )

// const AnimatedHeaderComponent = ({title, onPress, style, headerStyle, ...props}) => (
//     <Animated.View
//         style={[styles.animatedHeader, {...style}]}
//         {...props}
//     >
//         <Surface style={[styles.headerWrapper, headerStyle]}>
//             <View style={styles.headerTitleWrapper}>
//                 <Text 
//                    ellipsizeMode="tail"
//                    numberOfLines={2}
//                     style={styles.headerTitle}
//                 >
//                     {title || 'Title'}
//                 </Text>
//             </View>
//             <TouchableOpacity
//                 onPress={onPress}
//             >
//                 <Icon name="ios-close-circle-outline" size={28} color={Styles.primaryColor}/>
//             </TouchableOpacity>
//         </Surface>
//     </Animated.View>
// )

class ShowEventScreen extends React.Component{

  
     

    state = {
        video: false,
        pdf: false, 
        epub: false,
        value: 0,
        showHeader: true,
        epubLoading: true,
        noInternet: false,
        scale: 1
    }

  

    // componentWillMount() {
    //     this.panResponder = PanResponder.create({
    //         onStartShouldSetPanResponder: () => true,
    //         onMoveShouldSetPanResponder: () => true,
    //         onPanResponderMove: () => {
    //             Animated.event([
    //                 null,
    //                 {dy: this.state.pan.y, dx: this.state.pan.x}
    //             ])
    //         },
    //         onPanResponderRelease: (e, gestureState) => {               
    //             if(gestureState.dy < 1) {
    //                 this.hideHeader();
    //             }else {
    //                 this.showHeader();
    //             }
                
    //         }
    //     })
    // }

    componentDidMount() {
    
        const {
             contentUrl,
            contentType,
            html_content,
            title,
            id,
            subjectId,
            examId,
            topicId,
            formLibrary,
        } = this.props.contentData || {};
        // console.log(this.props.contentData, "Asdlasd")
          const contentId = id;
     
         if(!html_content && contentType === 'epub'){
            this.props.getGetHtmlContent({subjectId, examId, topicId, contentId}, formLibrary);

         }

        if ((contentUrl || html_content)&& contentType) {                       

            if(contentType === 'pdf') {
                this.setState({
                    pdf: true,
                    contentUrl
                })
            }

            if(contentType === 'video') {
                this.setState({
                    video: true,
                    contentUrl
                })
            }

            if(contentType === 'epub' || contentType === 'html') {
                 if(!html_content) {
                    
                 } else{
                     this.setState({
                         epub: true,
                         contentUrl: html_content
                     })
                 }
            }

        }  
        this.props.getGetJwPlayerSourceFiles('mediaId')     
    }

    componentDidUpdate(prevProps){
        if(prevProps.htmlContent !== this.props.htmlContent){
            if(this.props.htmlContent){
                this.setState({
                    epub: true
                })
            }
        }
    }

    componentWillUnmount() {
        
    }

    scaleIncrease = () => {
      alert('')
      this.setState({
        scale:this.state.scale + 0.5
      }, () => console.log(this.state.scale))
    }

    scaleDecrease = () => {
      this.setState({
        scale:this.state.scale - 0.5
      })
    }
  

    onBuffer = e => {
        console.log(e, 'on buffer');
    }
    
    onError = e => {
        console.log(e, 'on Error');
    }

    // showHeader = () => {

    //     Animated.parallel([
    //         Animated.timing(this.state.slideDown, {
    //             toValue: 60,
    //             duration: 300,
    //             // useNativeDriver: true
    //         }).start(),
    //         Animated.timing(this.state.scaleY, {
    //             toValue: 1,
    //             duration: 250,
    //             // useNativeDriver: true
    //         }).start()
    //     ])
       
    // }

    // checkInternet = (noInternet) => {
    //     this.setState({
    //         noInternet
    //     })
    // }

    // hideHeader = () => {
    //     Animated.parallel([
    //         Animated.timing(this.state.slideDown, {
    //             toValue: 0,
    //             duration: 300,
    //             // useNativeDriver: true
    //         }).start(),
    //         Animated.timing(this.state.scaleY, {
    //             toValue: 0,
    //             duration: 290,
    //             // useNativeDriver: true
    //         }).start()
    //     ])        
    // }

    loadProgress = (progress) => {
        const value = Math.floor(progress * 100);
        // console.log(value);
        this.setState({
            value
        })
    }

    // goBack = () => this.props.navigation.goBack();

    render() {
       
        const { video, pdf } = this.state;
        
        const {
          contentUrl,
         contentType,
         html_content,
        
     } = this.props.contentData || {};
        return (
     
        <div id="dialog">
          {
            this.props.loading && 
              <View style={{flex: 1, justifyContent: 'center', height: 'center'}}>
                <ActivityIndicator/>
              </View>
          }
          
        <Dialog
          fullScreen
          open={this.props.open}
          onClose={this.props.handleClose}
          // TransitionComponent={Transition}
          style={{marginTop: 0, zIndex:99999}}
        >
        {/* <div className="notes">
    
        <div className=" notes_btn text-white"
         style={{backgroundColor:primaryColor}} 
        onClick={this.toggleDrawer('right', true)}
        
        >Notes</div>
        <SwipeableDrawer
          className="right_side_drawer"
          anchor="right"
          open={this.state.right}
          onClose={this.toggleDrawer('right', false)}
          onOpen={this.toggleDrawer('right', true)}
        >
          <div
          className="right_side_drawer"
            tabIndex={0}
            role="button"
            // onClick={this.toggleDrawer('right', false)}
            // onKeyDown={this.toggleDrawer('right', false)}
          >
            {sideList}
          </div>
        </SwipeableDrawer>     
        </div> */}
          <List>
            <ListItem button style={{display: 'flex', justifyContent:'space-between', alignItems:'center',height: 50,
                backgroundColor: "blue",
                color: '#fff',
                paddingTop:11,
                fontSize: 16,
                fontWeight:400}} disableRipple>
            <IconButton color="inherit" 
            onClick={this.props.handleClose} 
            aria-label="Close">
                <CloseIcon />             
            </IconButton>
              {/* <div className="pt-1">
                {this.props.contentHeader}                  
              </div> */}
              {/* <div style={{display: 'flex', justifyContent:'center', alignItems:'center',
                height: 50,
                backgroundColor:'blue',
                color: '#fff',
                paddingTop:11,
                fontSize: 16,
                fontWeight:400
            }}>             
              
                 
                  <MultipleContentSelectComponent allContentData={this.props.allContentData} data={this.props.data} content={this.state.content} textField={classes.textField} handleChange={this.handleChange}/>
                
              </div> */}
            </ListItem>
          </List>      
            <div >
               
              {
                      contentType === 'video'
                      ? (
                        // <JwPlayer 
                        //   url={this.props.contentData}
                        //   // youtubeConfig={{ playerVars: { showinfo: 1 } }}
                        //   className="react_video"
                        //   config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                        //   controls= {true}
                        //   playing
                        //   playsinline={true}
                        //   onEnded={() => this.autoPlayNextVideo()}
                        //   onProgress={(data) => {
                        //     this.setState({
                        //       videoPlayedSeconds: data.playedSeconds
                        //     })
                        //   }}
                        // />
                        <div style={{maxWidth: '800px', maxHeight: '600px', margin: 'auto', alignSelf: 'center'}}>
                          
                          {
                            !this.props.sourceVideoLoading && this.props.sourceVideoFileInfo &&
                              <JwPlayer
                                contentUrl={contentUrl}
                              />
                          }

                        </div>
                                        
                      )
                      
                      : contentType ==="pdf" 
                      ? (
                        <div style={{height:'100vh',backgroundColor: "#fff"}}> 
                          <div className="p-1" style={{display:'flex', justifyContent:'center', alignItems:'center', position:'fixed', width:'100%', top:"9%"}}>
                              <div style={{width:300, height:40, backgroundColor:'#323643', display:'flex', justifyContent:'center'}}>
                              <Remove  className="ml-2 mt-1" onClick={this.scaleDecrease}  style={{color:'#fff', width:32, height:32}}/>
                              0
                              <ZoomIn className="p-1 ml-2 mt-1" style={{color:'#fff', width:32, height:32}}/>
                              <Add className="mt-1" onClick={this.scaleIncrease} style={{color:'#fff', width:32, height:32}}/>
                             
                              </div>  
                            
                          </div>  
                          <div  style={{marginTop: 10}}>
                              <PDFViewer 
                              document={{
                                fileType:'pdf',
                                url: contentUrl,   
                                
                                } 

                              }
                                scale={this.state.scale}
                                css="customViewer"
                                navigation={{
                                  elements: {
                                    previousPageBtn: CustomPrevButton,
                                    nextPageBtn: CustomNextButton,
                                    pages: CustomPages
                                  }
                                }}

                              
                              />

                          </div>

                      </div>
                      )
                      
                     : contentType ==="epub" ?
                       (
                         <div style={{padding: 5}}>
                            <div dangerouslySetInnerHTML={{__html: this.props.htmlContent && this.props.htmlContent.html_content}} style={{padding: 5, userSelect :' none'}}>

                            </div>
                         </div>
                       )

                      : null 
                       

                    
                   
              }
          </div>    
        </Dialog>
        </div>
        )
    }
}
const mapStatesToProps = state => {
    console.log(state)
    const htmlContent = state.getHtmlContentInfo && state.getHtmlContentInfo.response 
                       && (state.getHtmlContentInfo.response.material || state.getHtmlContentInfo.response.library_content)
    const loading =  state.getHtmlContentInfo && state.getHtmlContentInfo.loading;                  
    const error =  state.getHtmlContentInfo && state.getHtmlContentInfo.error;        
    const sourceVideoFileInfo =  state.JwPlayerSourceInfo && state.JwPlayerSourceInfo.response
    && state.JwPlayerSourceInfo.response.playlist[0];
const sourceVideoLoading =  state.JwPlayerSourceInfo && state.JwPlayerSourceInfo.loading          
    return {
        htmlContent,
        loading,
        error,
        sourceVideoFileInfo,
        sourceVideoLoading
    }
}

export default connect(mapStatesToProps, {getGetHtmlContent, 
  dispatchClearGetHtmlContent, getGetJwPlayerSourceFiles, clearGetJwPlayerSourceFiles})(withRouter(ShowEventScreen));

const styles = StyleSheet.create({
    backgroundVideo: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex:8888
    },
    pdf: {
        flex:1,
        width:Dimensions.get('window').width,
    },
    pdfWrapper: {
        position: 'relative',       
        flex: 1,
        // width: deviceWidth
        width: '100%'
    },
    animatedHeader: {
        // width: deviceWidth,
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,      
        // borderWidth: 2,
        // height: 60,
        backgroundColor: '#fff',
        zIndex: 100,
        // backgroundColor: 'red'
    },
    headerWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 12,
        // paddingVertical: 16,
        elevation: 8,
        height: '100%',
        width: '100%'
    },
    headerTitleWrapper: {
        // borderWidth: 1,
        flex: 1
    },
    headerTitle: {
        fontSize: 18,
    },
    videoWrapper: {
        // height: videoHeight,
        // width: deviceWidth,
        // borderWidth: 2
    },
    percentageLoader:{
        borderWidth: 2,
         borderRadius: 50, 
         width: 64,
          height: 64, 
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: Styles.successColor

    },
    // inner:{  
    //     width: "100%",  
    //     height: 30,  
    //     borderRadius: 15,  
    //     backgroundColor:"green",  
    //   },  
      label:{  
        fontSize:18,  
        color: "black",  
        position: "absolute",  
        zIndex: 1,  
        alignSelf: "center",  
      }
})



// import X from './animate'
